const e = new Error("Please connect wallet first.");
export {
  e as ERROR_CONNECT_WALLET
};
//# sourceMappingURL=errors.mjs.map
